<template>
  <div v-if="activeVendor && getUserData" class="main-page">
    <scan-and-go-messages v-if="isScanEnabled" />
    <app-page-wrapper-grid class="menu-wide d-flex-column p-b-20" remove-margin-top>
      <div class="favorites">
        <template v-if="nonReactiveFavorites.length">
          <app-link
            app-link
            :route-to="prevRoute ? prevRoute.path : { name: ROUTE_NAMES.MENU }"
            class="iw-hyperlink favorites__back"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15">
              <g fill="none" fill-rule="evenodd">
                <g stroke="currentColor" stroke-width="2">
                  <g>
                    <path d="M8 0L0 7.5 8 15" transform="translate(-14 -75) translate(16 76)" />
                    <path stroke-linecap="square" d="M1.633 7.5L19.367 7.5" transform="translate(-14 -75) translate(16 76)" />
                  </g>
                </g>
              </g>
            </svg>
            Menu
          </app-link>
          <h1 class="iw-page-title favorites__title">Favorites</h1>
          <div class="iw-layout-grid__row">
            <vendor-menu-item
              v-for="fav in nonReactiveFavorites"
              :key="fav.id"
              :menu-item="fav"
              class="iw-layout-grid__col--span-6-desktop iw-layout-grid__col--span-4-phone"
            >
            </vendor-menu-item>
          </div>
        </template>
        <template v-else>
          <div class="no-items-wrapper">
            <div class="favorites-no-items">
              <div class="favorites-no-items-img m-t-20 m-b-20">
                <img src="@/assets/images/fav-added.svg" alt="customize" />
              </div>
              {{ noFavorites }}
            </div>
          </div>
        </template>
      </div>
    </app-page-wrapper-grid>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import VendorMenuItem from "@/routes/menu/components/menu-list/menu-item/VendorMenuItem";
import AppPageWrapperGrid from "@/components/base/app-page-wrapper-grid/AppPageWrapperGrid";
import { ROUTE_NAMES, OAPI_API_TYPE } from "@/utils";

export const ScanAndGoMessages = defineAsyncComponent(() => import("@/components/messages/ScanAndGoMessages"));
export const MSG_NO_FAVORITES = "You do not have any available favorites.";

export default {
  name: "Favorites",
  components: {
    VendorMenuItem,
    ScanAndGoMessages,
    AppPageWrapperGrid
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path !== "/") vm.prevRoute = from;
    });
  },
  data() {
    return {
      noFavorites: MSG_NO_FAVORITES,
      prevRoute: null,
      nonReactiveFavorites: [],
      ROUTE_NAMES
    };
  },
  computed: {
    ...mapGetters({
      activeVendor: "vendor/getActiveVendor",
      getUserData: "user/getUserData",
      favorites: "user/getFavoriteItems",
      APIType: "venueSettings/APIType"
    }),
    isScanEnabled() {
      return this.APIType === OAPI_API_TYPE && this.activeVendor?.scanToAddToCart;
    }
  },
  beforeUpdate: function () {
    if (!this.activeVendor || !this.getUserData)
      this.$router.push({
        name: ROUTE_NAMES.VENDOR_PICKER
      });
  },
  mounted() {
    this.nonReactiveFavorites = [...this.favorites];
  }
};
</script>

<style lang="scss" scoped>
.dark {
  .favorites {
    &__title {
      @include respond-to-mobile {
        color: #fff;
      }
    }
  }
}

.main-page {
  min-height: auto;
  margin-top: $headerMobileHeight;
}

.favorites {
  width: 100%;
  flex-grow: 1;

  &__title {
    padding-left: 28px;
    padding-bottom: 12px;
    @include respond-to-mobile {
      padding-left: 24px;
      padding-bottom: ($spacer * 0.5);
    }
  }

  &-no-items {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 2em;
    font-weight: 200;
    @include respond-to-mobile {
      font-size: 1.5em;
    }
  }

  &__back {
    padding-top: 24px;
    padding-bottom: 20px;
    display: flex;
    align-self: center;
    color: $group-3-color-2;

    svg {
      color: $group-3-color-4;
      width: 20px;
      height: 15px;
      align-self: center;
      margin-right: ($spacer * 0.5);
      margin-left: 28px;
      @include respond-to-mobile {
        margin-left: 24px;
      }
    }
  }
}
.no-items-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 60%;
}
</style>
